import { useLocation } from 'react-router-dom';
import { AddInstantBillActivity } from '@melio/ap-activities';
import { AddInstantBillFormWidgetFields } from '@melio/ap-widgets';

import { useAddInstantBillRedirects } from '@/hooks/useAddInstantBillRedirects.hooks';

type Props = {
  defaultValues?: Partial<AddInstantBillFormWidgetFields>;
};

export const AddInstantBillScreen = ({ defaultValues }: Props) => {
  const { state } = useLocation();
  const { returnUrl } = (state as { returnUrl?: string }) || {};
  const { onDone, onClose } = useAddInstantBillRedirects(returnUrl);

  return (
    <AddInstantBillActivity onClose={onClose} onDone={onDone} onGoToDashboard={onClose} defaultValues={defaultValues} />
  );
};
